__turbopack_context__.v({
  "errorText": "dropdown-module-scss-module__cqLMqG__errorText",
  "errorWrapper": "dropdown-module-scss-module__cqLMqG__errorWrapper",
  "focusWrapper": "dropdown-module-scss-module__cqLMqG__focusWrapper",
  "homePrequalDropdown": "dropdown-module-scss-module__cqLMqG__homePrequalDropdown",
  "icon": "dropdown-module-scss-module__cqLMqG__icon",
  "option": "dropdown-module-scss-module__cqLMqG__option",
  "select": "dropdown-module-scss-module__cqLMqG__select",
  "shadow": "dropdown-module-scss-module__cqLMqG__shadow",
  "wrapper": "dropdown-module-scss-module__cqLMqG__wrapper",
});
